import { render, staticRenderFns } from "./LenderCard.vue?vue&type=template&id=7895f654&"
import script from "./LenderCard.vue?vue&type=script&lang=ts&"
export * from "./LenderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports